export const basketEvents = new EventTarget();

export const BASKET_UPDATED = 'basket:updated';
